import { render } from "./verify-account-modal.vue?vue&type=template&id=1d761a9e&ts=true"
import script from "./verify-account-modal.vue?vue&type=script&lang=ts"
export * from "./verify-account-modal.vue?vue&type=script&lang=ts"

import "./verify-account-modal.vue?vue&type=style&index=0&id=1d761a9e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__